<template>
  <div class="col-12 " :dir="locale === 'ar' ? 'rtl' : 'ltr'">
    <div class="card mb-5 " style="margin-top: 4rem; overflow: visible">
      <div class="card-header p-0 position-relative mt-n4 mx-3 z-index-2" style="height: 60px;">
        <div class="bg-primary shadow-primary border-radius-lg pt-4 pb-3 h-100">
          <div class="d-flex justify-content-between align-items-center">
            <h6 class="text-white text-capitalize ps-3 pe-3 mb-0">{{ $t('classes.breadcrumbs.addClass') }}</h6>
          </div>
        </div>
      </div>
   
      <div class="card-body px-0 pb-2 mx-2 ">
        <div class="row justify-content-center">
          <div class="col-md-6">
            <ClassForm 
              ref="classForm"
              @submit="handleSubmit" 
              @cancel="handleCancel" 
              @validation-error="handleValidationError"
            />
            
            <div class="d-flex gap-3 mt-3">
              <button 
                type="button" 
                class="btn btn-primary flex-grow-1"
                @click="submitForm"
                :disabled="isSubmitting"
              >
                <span v-if="isSubmitting">
                  <i class="fas fa-spinner fa-spin" :class="locale === 'ar' ? 'ms-2' : 'me-2'"></i>
                  {{ $t('loading.message') }}
                </span> 
                <span v-else>
                  <i class="fas fa-save" :class="locale === 'ar' ? 'ms-2' : 'me-2'"></i>
                  {{ $t('classes.actions.addNew') }}
                </span>
              </button>
              <button 
                type="button" 
                class="btn btn-outline-secondary flex-grow-1"
                @click="handleCancel"
                :disabled="isSubmitting"
              >
                <i class="fas fa-times" :class="locale === 'ar' ? 'ms-2' : 'me-2'"></i>
                {{ $t('baseDialog.cancel') }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { useI18n } from 'vue-i18n';
import ClassForm from '@/components/features/classes/forms/ClassForm.vue';
import { useToast } from 'vue-toastification'

const { t, locale } = useI18n();
const toast = useToast()
const router = useRouter();
const store = useStore();
const classForm = ref(null);
const isSubmitting = ref(false);

const submitForm = () => {
  classForm.value.submit();
};

const handleSubmit = async (classData) => {
  isSubmitting.value = true;
  try {
    await store.dispatch('classes/createClass', classData);
    router.push('/classes');
    toast.success(t('classes.messages.addSuccess'));
  } catch (error) {
    console.error('Error adding class:', error);
    
    if (error.response?.data?.errors?.name) {
      classForm.value.setServerErrors(error.response.data.errors);
    } else {
      toast.error(t('classes.messages.addError'));
    }
  } finally {
    isSubmitting.value = false; 
  }
};

const handleValidationError = () => {
  toast.warning(t('classes.messages.validationError'));
};

const handleCancel = () => {
  router.push('/classes');
};
</script>